<template>
    <div class="container">
      <div>
          <h4>{{ $t("insureText.tbsm.title") }}</h4>
          <p class="pre_" v-html="$t('insureText.tbsm.' + p)"></p>
      </div>
    </div>
</template>
<script>
export default {
    data() {
      return {
        p: ''
      }
    },
    computed: {
      lang() {
        return this.$i18n.locale == 'zh-cn' ? 1 : 2
      }
    },
    mounted() {
      this.p = this.$route.query.p
    }
}
</script>
<style lang="scss" scoped>
.container{
  line-height: 1.8;
}
</style>